<div class="login-background">
    <div class="login-center-container" [ngClass]="{ 'registration-form': hasHitLoggedIn }">
        <div *ngIf="!hasHitLoggedIn" class="hit-login-container">
            <div class="one-row login-logo-row">
                <div class="vetvet-logo">VETVET<span class="vetvet-dot">.</span></div>
            </div>
            <div class="login-header-block">
                <div class="login-title">Registrierung</div>
                <div class="login-hint">HI-Tier Anmeldung</div>
            </div>

            <div style="padding-left: 0.8em; padding-right: 0.8em">
                <div class="info-box">
                    <p class="hit-form-text">
                        Damit Sie den vollen Funktionsumfang von
                        <strong>vetvet.de</strong> nutzen können, ist eine einmalige Anmeldung bei HI-Tier notwendig.
                    </p>
                </div>
            </div>

            <mat-form-field class="hit-form-field" appearance="fill">
                <mat-label>VVVO-Nummer</mat-label>
                <input
                    matInput
                    type="text"
                    placeholder="VVVO-Nummer"
                    [formControl]="hitVvvoCtrl"
                    maxlength="15"
                    autocomplete="username"
                    (keyup.enter)="hitLogin()"
                />
                <span matSuffix style="font-size: 0.8em">{{ hitVvvoCtrl.value.length }}/15</span>
                <mat-error class="input-error" *ngIf="hitVvvoCtrl.hasError('required')"
                    >Die VVVO-Nummer ist ein Pflichtfeld.
                </mat-error>
                <mat-error class="input-error" *ngIf="hitVvvoCtrl.hasError('pattern')"
                    >Die VVVO-Nummer muss 15 Zeichen lang sein.
                </mat-error>
            </mat-form-field>

            <mat-form-field class="hit-form-field" appearance="fill" style="margin-top: 10px">
                <mat-label>Passwort</mat-label>
                <input
                    #hitPinInput="matInput"
                    matInput
                    placeholder="Passwort"
                    [type]="hidePassword ? 'password' : 'text'"
                    [formControl]="hitPinCtrl"
                    autocomplete="current-password"
                    (keyup.enter)="hitLogin()"
                />
                <mat-error class="input-error" *ngIf="hitPinCtrl.hasError('required')"
                    >Das Passwort ist ein Pflichtfeld.
                </mat-error>
                <mat-icon matSuffix (click)="hidePassword = !hidePassword"
                    >{{ hidePassword ? "visibility" : "visibility_off" }}
                </mat-icon>
            </mat-form-field>

            <div class="hit-form-field">
                <button
                    mat-flat-button
                    type="button"
                    color="primary"
                    (click)="hitLogin()"
                    [disabled]="isLoading"
                    class="login-submit-btn"
                >
                    Anmelden
                </button>
            </div>

            <div class="login-links-row login-links-row-right">
                <button
                    (click)="backToLogin()"
                    mat-button
                    type="button"
                    class="login-link-btn login-link-btn-small"
                    [disabled]="isLoading"
                >
                    <span class="kiene-color login-link-btn-small-text">Zurück zum Login</span>
                </button>
            </div>
        </div>

        <div *ngIf="hasHitLoggedIn && hitLoginResponse">
            <div class="one-row login-logo-row">
                <div class="vetvet-logo">VETVET<span class="vetvet-dot">.</span></div>
            </div>
            <div class="login-header-block">
                <div class="login-title">Registrierung</div>
                <!-- <div class="login-hint">vetvet</div> -->
            </div>

            <div class="stepper-container">
                <mat-vertical-stepper [linear]="true" #stepper>
                    <!-- Schritt 1: Benutzertyp -->
                    <mat-step [stepControl]="step1FormGroup">
                        <ng-template matStepLabel>Ihre Rolle festlegen</ng-template>
                        <ng-template matStepperIcon="edit">
                            <mat-icon>check</mat-icon>
                        </ng-template>

                        <div class="form-section">
                            <!-- Text direkt über der Auswahl platzieren -->
                            <div class="user-type-selection">
                                <div class="selection-instruction">
                                    <p
                                        >Bitte wählen Sie aus, ob Sie sich als Landwirt oder Viehhändler registrieren
                                        möchten.</p
                                    >
                                </div>

                                <div class="user-type-cards">
                                    <mat-card
                                        class="user-type-card"
                                        [class.selected]="landwirtHaendlerCtrl.value === 0"
                                        (click)="selectUserType(0)"
                                    >
                                        <mat-card-content>
                                            <span
                                                class="user-type-emoji"
                                                style="font-size: 2.2em; display: block; margin-bottom: 8px"
                                                >🐄</span
                                            >
                                            <h3>Landwirt</h3>
                                            <p>Für landwirtschaftliche Betriebe</p>
                                        </mat-card-content>
                                    </mat-card>

                                    <mat-card
                                        class="user-type-card"
                                        [class.selected]="landwirtHaendlerCtrl.value === 1"
                                        (click)="selectUserType(1)"
                                    >
                                        <mat-card-content>
                                            <span
                                                class="user-type-emoji"
                                                style="font-size: 2.2em; display: block; margin-bottom: 8px"
                                                >🤝</span
                                            >
                                            <h3>Viehhändler</h3>
                                            <p>Für Viehhandelsunternehmen</p>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button mat-flat-button class="weiter-button" (click)="validateAndGoToStep2()"
                                >Weiter</button
                            >
                        </div>
                    </mat-step>

                    <!-- Schritt 2: Benutzerinformationen -->
                    <mat-step [stepControl]="step2FormGroup">
                        <ng-template matStepLabel>Ihr persönlicher Account</ng-template>
                        <ng-template matStepperIcon="edit">
                            <mat-icon>check</mat-icon>
                        </ng-template>

                        <!-- Account Daten Card -->
                        <div class="form-section">
                            <mat-card class="step-intro-card">
                                <mat-card-content>
                                    <div class="intro-content">
                                        <mat-icon class="intro-icon">account_circle</mat-icon>
                                        <p
                                            >Erstellen Sie Ihren persönlichen vetvet-Account mit Ihren Zugangsdaten.
                                            Diese benötigen Sie für alle zukünftigen Anmeldungen.</p
                                        >
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <!-- Name Felder nebeneinander -->
                            <div class="form-row responsive-row">
                                <mat-form-field class="form-field-half">
                                    <mat-label>Vorname</mat-label>
                                    <input
                                        required
                                        matInput
                                        placeholder="Vorname"
                                        type="text"
                                        [formControl]="vornameCtrl"
                                        autocomplete="given-name"
                                    />
                                    <mat-error class="input-error" *ngIf="vornameCtrl.hasError('required')"
                                        >Der Vorname ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="form-field-half">
                                    <mat-label>Nachname</mat-label>
                                    <input
                                        required
                                        matInput
                                        placeholder="Nachname"
                                        type="text"
                                        [formControl]="nachnameCtrl"
                                        autocomplete="family-name"
                                    />
                                    <mat-error class="input-error" *ngIf="nachnameCtrl.hasError('required')"
                                        >Der Nachname ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- E-Mail allein -->
                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>E-Mail Adresse</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="email"
                                        placeholder="E-Mail"
                                        [formControl]="benutzerEmailCtrl"
                                        autocomplete="email"
                                    />
                                    <mat-error class="input-error" *ngIf="benutzerEmailCtrl.errors"
                                        >Die E-Mail Adresse ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Passwort Felder untereinander mit Anforderungsanzeige -->
                            <div class="form-row password-section">
                                <div class="password-fields">
                                    <mat-form-field class="form-field-full">
                                        <mat-label>Passwort</mat-label>
                                        <input
                                            required
                                            matInput
                                            placeholder="Passwort"
                                            [type]="hidePassword ? 'password' : 'text'"
                                            [formControl]="passwortCtrl"
                                            autocomplete="new-password"
                                        />
                                        <mat-icon matSuffix (click)="hidePassword = !hidePassword"
                                            >{{ hidePassword ? "visibility" : "visibility_off" }}
                                        </mat-icon>
                                        <mat-error class="input-error" *ngIf="passwortCtrl.hasError('pattern')"
                                            >Das Passwort muss mindestens 6 Zeichen lang sein.
                                        </mat-error>
                                        <mat-error class="input-error" *ngIf="passwortCtrl.hasError('mismatch')"
                                            >Die eingegebenen Passwörter stimmen nicht überein!
                                        </mat-error>
                                        <mat-error class="input-error" *ngIf="passwortCtrl.hasError('required')"
                                            >Das Passwort ist ein Pflichtfeld.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field class="form-field-full">
                                        <mat-label>Passwort wiederholen</mat-label>
                                        <input
                                            required
                                            matInput
                                            placeholder="Passwort"
                                            [type]="hidePassword ? 'password' : 'text'"
                                            [formControl]="passwortWdhCtrl"
                                            autocomplete="new-password"
                                        />
                                        <mat-icon matSuffix (click)="hidePassword = !hidePassword"
                                            >{{ hidePassword ? "visibility" : "visibility_off" }}
                                        </mat-icon>
                                        <mat-error class="input-error" *ngIf="passwortWdhCtrl.hasError('pattern')"
                                            >Das Passwort muss mindestens 6 Zeichen lang sein.
                                        </mat-error>
                                        <mat-error class="input-error" *ngIf="passwortWdhCtrl.hasError('mismatch')"
                                            >Die eingegebenen Passwörter stimmen nicht überein!
                                        </mat-error>
                                        <mat-error class="input-error" *ngIf="passwortWdhCtrl.hasError('required')"
                                            >Das Passwort ist ein Pflichtfeld.
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="password-requirements"
                                    style="
                                        background: #fff;
                                        border: 1.5px solid #e0e0e0;
                                        border-radius: 12px;
                                        box-shadow: 0 2px 8px rgba(25, 126, 62, 0.06);
                                        padding: 20px 24px;
                                    "
                                >
                                    <div style="font-weight: 600; color: #197e3e; margin-bottom: 8px"
                                        >Passwort-Anforderungen</div
                                    >
                                    <ul style="list-style: none; padding: 0; margin: 0">
                                        <!-- Mindestlänge -->
                                        <li
                                            class="requirement-item"
                                            [class.fulfilled]="passwortCtrl.value?.length >= MIN_PASSWORD_LENGTH"
                                            [class.error]="
                                                passwortCtrl.touched &&
                                                passwortCtrl.value &&
                                                passwortCtrl.value.length > 0 &&
                                                passwortCtrl.value.length < MIN_PASSWORD_LENGTH
                                            "
                                            style="display: flex; align-items: center; margin-bottom: 6px"
                                        >
                                            <mat-icon style="margin-right: 8px">
                                                {{
                                                    passwortCtrl.value?.length >= MIN_PASSWORD_LENGTH
                                                        ? "check_circle"
                                                        : "radio_button_unchecked"
                                                }}
                                            </mat-icon>
                                            <span>Mindestens {{ MIN_PASSWORD_LENGTH }} Zeichen lang</span>
                                        </li>
                                        <!-- Großbuchstabe -->
                                        <li
                                            class="requirement-item"
                                            [class.fulfilled]="hasUppercase(passwortCtrl.value)"
                                            [class.error]="
                                                passwortCtrl.touched &&
                                                passwortCtrl.value &&
                                                !hasUppercase(passwortCtrl.value)
                                            "
                                            style="display: flex; align-items: center; margin-bottom: 6px"
                                        >
                                            <mat-icon style="margin-right: 8px">
                                                {{
                                                    hasUppercase(passwortCtrl.value)
                                                        ? "check_circle"
                                                        : "radio_button_unchecked"
                                                }}
                                            </mat-icon>
                                            <span>Mindestens einen Großbuchstaben</span>
                                        </li>
                                        <!-- Kleinbuchstabe -->
                                        <li
                                            class="requirement-item"
                                            [class.fulfilled]="hasLowercase(passwortCtrl.value)"
                                            [class.error]="
                                                passwortCtrl.touched &&
                                                passwortCtrl.value &&
                                                !hasLowercase(passwortCtrl.value)
                                            "
                                            style="display: flex; align-items: center; margin-bottom: 6px"
                                        >
                                            <mat-icon style="margin-right: 8px">
                                                {{
                                                    hasLowercase(passwortCtrl.value)
                                                        ? "check_circle"
                                                        : "radio_button_unchecked"
                                                }}
                                            </mat-icon>
                                            <span>Mindestens einen Kleinbuchstaben</span>
                                        </li>
                                        <!-- Zahl -->
                                        <li
                                            class="requirement-item"
                                            [class.fulfilled]="hasNumber(passwortCtrl.value)"
                                            [class.error]="
                                                passwortCtrl.touched &&
                                                passwortCtrl.value &&
                                                !hasNumber(passwortCtrl.value)
                                            "
                                            style="display: flex; align-items: center; margin-bottom: 6px"
                                        >
                                            <mat-icon style="margin-right: 8px">
                                                {{
                                                    hasNumber(passwortCtrl.value)
                                                        ? "check_circle"
                                                        : "radio_button_unchecked"
                                                }}
                                            </mat-icon>
                                            <span>Mindestens eine Zahl</span>
                                        </li>
                                        <!-- Beide Passwörter identisch -->
                                        <li
                                            class="requirement-item"
                                            [class.fulfilled]="
                                                passwortCtrl.value &&
                                                passwortWdhCtrl.value &&
                                                passwortCtrl.value === passwortWdhCtrl.value
                                            "
                                            [class.error]="
                                                (passwortWdhCtrl.touched || passwortCtrl.touched) &&
                                                passwortWdhCtrl.value &&
                                                passwortCtrl.value !== passwortWdhCtrl.value
                                            "
                                            style="display: flex; align-items: center"
                                        >
                                            <mat-icon style="margin-right: 8px">
                                                {{
                                                    passwortCtrl.value &&
                                                    passwortWdhCtrl.value &&
                                                    passwortCtrl.value === passwortWdhCtrl.value
                                                        ? "check_circle"
                                                        : "radio_button_unchecked"
                                                }}
                                            </mat-icon>
                                            <span>Beide Passwörter sind identisch</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="agb-field" [class.mat-form-field-invalid]="agbCtrl.invalid && agbCtrl.touched">
                                <mat-checkbox [formControl]="agbCtrl">
                                    Ja, ich stimme den
                                    <b
                                        ><a
                                            href="https://vetvet.de/agb"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="agb-link"
                                            >AGBs</a
                                        ></b
                                    >
                                    zu.
                                </mat-checkbox>
                                <div class="mat-error input-error" *ngIf="agbCtrl.invalid && agbCtrl.touched">
                                    Die AGBs müssen akzeptiert werden.
                                </div>
                            </div>
                        </div>

                        <div>
                            <button mat-button (click)="goToPreviousStep()" matStepperPrevious>Zurück</button>
                            <button
                                mat-flat-button
                                class="weiter-button"
                                (click)="validateAndGoToStep3()"
                                [disabled]="!agbCtrl.valid"
                                >Weiter</button
                            >
                        </div>
                    </mat-step>

                    <!-- Schritt 3: Betriebsinformationen -->
                    <mat-step [stepControl]="step3FormGroup">
                        <ng-template matStepLabel>Ihr Betrieb</ng-template>
                        <ng-template matStepperIcon="edit">
                            <mat-icon>check</mat-icon>
                        </ng-template>

                        <div class="form-section">
                            <mat-card class="step-intro-card">
                                <mat-card-content>
                                    <div class="intro-content">
                                        <mat-icon class="intro-icon">business</mat-icon>
                                        <p>Vervollständigen Sie Ihre Betriebsdaten für die vetvet-Registrierung.</p>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <!-- VVVO allein -->
                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>VVVO</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        disabled
                                        placeholder="VVVO"
                                        [(ngModel)]="hitLoginResponse.vvvo"
                                        autocomplete="vvvo"
                                    />
                                </mat-form-field>
                            </div>

                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>Firmenname</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        placeholder="Firmenname"
                                        [formControl]="firmennameCtrl"
                                        autocomplete="company"
                                    />
                                    <mat-error class="input-error" *ngIf="firmennameCtrl.hasError('required')"
                                        >Der Firmenname ist ein Pflichtfeld.</mat-error
                                    >
                                </mat-form-field>
                            </div>
                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>E-Mail Adresse</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="email"
                                        placeholder="E-Mail"
                                        [formControl]="hitEmailCtrl"
                                        autocomplete="email"
                                        data-cy="register-betrieb-email"
                                    />
                                    <mat-error class="input-error" *ngIf="hitEmailCtrl.hasError('email')"
                                        >Die E-Mail Adresse ist ungültig. Beispielformat: ihre&#64;email.de
                                    </mat-error>
                                    <mat-error class="input-error" *ngIf="hitEmailCtrl.hasError('required')"
                                        >Die E-Mail Adresse ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>Betriebsart</mat-label>
                                    <mat-select [formControl]="betriebsartCtrl" [compareWith]="compareBetriebsarten">
                                        <mat-option *ngFor="let betriebsart of betriebsarten" [value]="betriebsart">
                                            {{ betriebsart.bezeichnung }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- SGS Nummer nur anzeigen, wenn Mastkälber gewählt -->
                            <div class="form-row" *ngIf="betriebsartCtrl.value?.bezeichnung === 'Mastkälber'">
                                <mat-form-field class="form-field-full">
                                    <mat-label>SGS Nummer</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        placeholder="SGS Nummer"
                                        [formControl]="sgsNummerCtrl"
                                        autocomplete="sgs"
                                    />
                                    <mat-error class="input-error" *ngIf="sgsNummerCtrl.hasError('required')">
                                        Die SGS Nummer ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Telefonnummern nebeneinander -->
                            <div class="form-row responsive-row">
                                <mat-form-field class="form-field-half">
                                    <mat-label>Telefonnummer</mat-label>
                                    <input
                                        matInput
                                        type="tel"
                                        placeholder="z.B. 0123 456789"
                                        [formControl]="telefonnummerCtrl"
                                        autocomplete="tel"
                                    />
                                    <mat-error class="input-error" *ngIf="telefonnummerCtrl.hasError('pattern')">
                                        Bitte geben Sie eine gültige deutsche Telefonnummer ein (z.B. 0123 456789).
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="form-field-half">
                                    <mat-label>Handynummer</mat-label>
                                    <input
                                        matInput
                                        type="tel"
                                        placeholder="z.B. 0151 12345678"
                                        [formControl]="handynummerCtrl"
                                        autocomplete="tel"
                                    />
                                    <mat-error class="input-error" *ngIf="handynummerCtrl.hasError('pattern')">
                                        Bitte geben Sie eine gültige deutsche Handynummer ein (z.B. 0151 12345678).
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- Adresse: Straße allein -->
                            <div class="form-row">
                                <mat-form-field class="form-field-full">
                                    <mat-label>Straße</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        placeholder="Straße Hausnr."
                                        [formControl]="strasseCtrl"
                                        autocomplete="street-address"
                                    />
                                    <mat-error class="input-error" *ngIf="strasseCtrl.hasError('required')"
                                        >Die Straße ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="form-row responsive-row">
                                <mat-form-field class="form-field-half">
                                    <mat-label>PLZ</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        placeholder="PLZ"
                                        [formControl]="plzCtrl"
                                        autocomplete="postal-code"
                                    />
                                    <mat-error class="input-error" *ngIf="plzCtrl.hasError('required')">
                                        Die PLZ ist ein Pflichtfeld.
                                    </mat-error>
                                    <mat-error class="input-error" *ngIf="plzCtrl.hasError('pattern')">
                                        Bitte geben Sie eine gültige PLZ (5 Ziffern) ein.
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="form-field-half">
                                    <mat-label>Ort</mat-label>
                                    <input
                                        required
                                        matInput
                                        type="text"
                                        placeholder="Ort"
                                        [formControl]="ortCtrl"
                                        autocomplete="address-level2"
                                    />
                                    <mat-error class="input-error" *ngIf="ortCtrl.hasError('required')">
                                        Der Ort ist ein Pflichtfeld.
                                    </mat-error>
                                </mat-form-field>
                            </div>

    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
        <!-- <p
            >Der Service kann nach der Registrierung 30 Tage kostenlos genutzt werden. </p>
           <p> Danach gilt die monatliche Preisstaffel: 
            Für den ersten Rinderbetrieb 20 € pro Monat, 
            für Betriebe 2–4 jeweils 10 € pro Monat, ab dem fünften Betrieb jeweils 5 € pro Monat. 
            Freigegebene Betriebe kosten ebenfalls jeweils 5 € pro Monat.</p
        > -->
        <button
            style="margin: 12px 0 12px 0; width: 33%"
            mat-flat-button
            type="button"
            color="accent"
            class="button"
            (click)="register()"
            [disabled]="isLoading || !agbCtrl.valid || !landwirtHaendlerCtrl.valid || !step3FormGroup.valid"
        >
            Registrieren
        </button>
    </div>
</div>
